var SingleImgAdjust = function() {
    this.init();
};

SingleImgAdjust.prototype = {
    init: function() {
        $('.single-entry').find('img').each(function() {
            var $this = $(this);
            $this.attr('width', '');
            $this.attr('height', '');
        });
        $('.list-type-news').find('img').each(function() {
            var $this = $(this);
            $this.attr('width', '');
            $this.attr('height', '');
        });
    }
};

module.exports = SingleImgAdjust;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/SingleImgAdjust.js
 **/